import { InjectionToken } from '@angular/core';

export const GOOGLE_ANALYTICS_AUTH = new InjectionToken<string>('Auth used for the Google Tag Manager live container');
